export default {
  'seo:default-description':
    'Premium Tiernahrung von Pets Deli | BARF-Menüs, Nassfutter, Trockenfutter & Snacks für Hunde und Katzen ✓ 100% artgerecht ✓ Lebensmittelqualität ✓ → jetzt entdecken!',
};
